module.exports = __webpack_public_path__ + "media/img/scholarships/English Year 11-23c8c145d39cbeb39b2e47e7cd373664.svg";